import React, { lazy } from "react";
import { BrowserRouter as Router, Navigate, Route, Routes } from "react-router-dom";
import { AppProvider } from "./state/AppState";
import Shell from "./components/layout/Shell";

const Overview = lazy(() => import("./pages/Overview"));
const Loans = lazy(() => import("./pages/Loans"));
const LoanDetail = lazy(() => import("./pages/LoanDetail"));
const Planner = lazy(() => import("./pages/Planner"));
const Investments = lazy(() => import("./pages/Investments"));
const Inflation = lazy(() => import("./pages/Inflation"));
const Reports = lazy(() => import("./pages/Reports"));
const Settings = lazy(() => import("./pages/Settings"));
const Features = lazy(() => import("./pages/Features"));
const PrivacyPolicy = lazy(() => import("./pages/PrivacyPolicy"));
const NotFound = lazy(() => import("./pages/NotFound"));

export default function App() {
  return (
    <AppProvider>
      <Router>
        <Routes>
          <Route element={<Shell />}>
            <Route index element={<Overview />} />
            <Route path="loans" element={<Loans />} />
            <Route path="loans/:id" element={<LoanDetail />} />
            <Route path="planner" element={<Planner />} />
            <Route path="investments" element={<Investments />} />
            {/* Original app URL for goal tracking; lands on the goal plan. */}
            <Route path="goal-tracking" element={<Investments />} />
            <Route path="inflation" element={<Inflation />} />
            <Route path="reports" element={<Reports />} />
            <Route path="settings" element={<Settings />} />
            <Route path="features" element={<Features />} />
            <Route path="privacy-policy" element={<PrivacyPolicy />} />
            <Route path="overview" element={<Navigate to="/" replace />} />
            <Route path="*" element={<NotFound />} />
          </Route>
        </Routes>
      </Router>
    </AppProvider>
  );
}
